import { Alert, Box, Typography } from '@mui/material';

interface FormatModeSelectorProps {
  hasForms: boolean;
}

const FormatModeSelector: React.FC<FormatModeSelectorProps> = ({ hasForms }) => {
  if (!hasForms) {
    return null;
  }

  return (
    <Box sx={{ mb: 4, px: 1 }}>
      <Alert severity="info" sx={{ '& .MuiAlert-message': { width: '100%' } }}>
        <Typography variant="subtitle2" gutterBottom>
          Returnable Forms Detected
        </Typography>
        <Typography variant="body2" paragraph>
          The system has detected forms and/or response schedules. An{' '}
          <strong>Extracted (Exclude Forms)</strong> outline is the best option here to avoid
          duplicating content between your forms and the narrative draft.
        </Typography>
        <Typography variant="body2">
          Your form file details have been sent to <strong>Step 12 (Generate Documents)</strong>{' '}
          where they can be populated after your draft is completed.
        </Typography>
      </Alert>
    </Box>
  );
};

export default FormatModeSelector;
